import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Home from '../page/home/Home';
import { BrowserRouter as Router } from 'react-router'



class HomePortal extends Component {
  render() {

    // Container ref
    let targetContainer = document.getElementById('react-tracks-home-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
      <Router>
        <Home />
      </Router>, targetContainer
    );
  }
}

export default HomePortal;